import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "p-menu",
  inject: ["setPopHowWorksShow"],
  data() {
    return {
      menu: null
    };
  },
  computed: {
    ...walletVuex.mapState(["isMobile"])
  },
  methods: {
    onMenu(item) {
      if (item.value === "howitworks") {
        this.setPopHowWorksShow(true);
        return;
      }
      this.$router.push(item.path);
    },
    setMenu() {
      let menu = [{
        label: this.$lang("Home"),
        value: "home",
        path: "/"
      }, {
        label: this.$lang("Portfolio"),
        value: "mytokens",
        path: "/myToken"
      }, {
        label: this.$lang("Referral"),
        value: "referral",
        path: "/referral"
      },
      // {
      //   label: this.$lang("Rewards"),
      //   value: "rewards",
      //   path: "/reward",
      // },
      {
        label: this.$lang("Ranking"),
        value: "ranking",
        path: "/ranking"
      }
      // {
      //   label: this.$lang("How it works"),
      //   value: "howitworks",
      // },
      ];
      // if (this.isMobile) {
      //   menu.pop();
      //   menu.push({
      //     label: this.$lang("More"),
      //     value: "more",
      //   });
      // }
      this.menu = menu;
    }
  },
  mounted() {
    this.setMenu();
  }
};